import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { StrategyDspCreativeType } from "@front/m19-api-client";
import { IIcon, IIconComponent, ILabelComponent, IRadioComponent, IRadioGroupComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspDealRefreshButtonComponent } from "@m19-board/dsp/dsp-media/dsp-deal-refresh-button.component";

type AwarenessMedia = StrategyDspCreativeType.STREAMING_TV | StrategyDspCreativeType.VIDEO_DEAL;

@Component({
  selector: "app-dsp-media-selector",
  imports: [
    DspDealRefreshButtonComponent,
    TranslocoDirective,
    IIconComponent,
    IRadioComponent,
    IRadioGroupComponent,
    ILabelComponent,
  ],
  templateUrl: "./dsp-media-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspMediaSelectorComponent {
  readonly Media = StrategyDspCreativeType;

  readonly media = model<AwarenessMedia | undefined>(undefined);
  readonly stvAvailable = input(true);
  readonly videoDealAvailable = input(true);

  readonly options: { media: AwarenessMedia; title: string; description: string; icon: IIcon }[] = [
    {
      media: StrategyDspCreativeType.VIDEO_DEAL,
      title: "dsp-media-selector.video_deal",
      description: "dsp-media-selector.video_deal_description",
      icon: "play",
    },
    {
      media: StrategyDspCreativeType.STREAMING_TV,
      title: "dsp-media-selector.streaming_tv",
      description: "dsp-media-selector.streaming_tv_description",
      icon: "tv",
    },
  ];

  select(media?: StrategyDspCreativeType) {
    if (media === StrategyDspCreativeType.STREAMING_TV && this.stvAvailable()) {
      this.media.set(media);
    } else if (media === StrategyDspCreativeType.VIDEO_DEAL && this.videoDealAvailable()) {
      this.media.set(media);
    }
  }
}
